import * as React from "react";
import isEven from "@functions/isEven";
import * as classess from "@styles/card.module.css";
import cx from "classnames";

const Card = (props) => {
  let counter = props.counter;
  return (
    <article
      className={cx(isEven(counter) ? classess.cardEven : classess.cardOdd)}
    >
      <figure>
        <img src={props.image} alt={props.altText} />
      </figure>
      <span className={classess.cardText}>{props.titleText}</span>
      <p>{props.descriptionText}</p>
    </article>
  );
};

export default Card;
